const lang = navigator.language

function formatStartAtForOverviewList (startAt: number): string {
  const options = { weekday: 'short', month: 'short', day: 'numeric', hour12: true, hour: 'numeric', minute: '2-digit' }
  let eventStartsAt = new Date(startAt * 1000)

  return eventStartsAt.toLocaleDateString(lang, options)
}

function isPastEvent (eventEndDate: number): boolean {
  const currentDate = new Date()
  const endDate = new Date(eventEndDate * 1000)

  return currentDate > endDate
}

function formatDateForEventView (eventStartDate: number, eventEndDate: number): string {
  const startDate = new Date(eventStartDate * 1000)
  const endDate = new Date(eventEndDate * 1000)

  const dateOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  }
  const timeOptions = {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit'
  }
  const dateTimeOptions = { ...dateOptions, ...timeOptions }
  const formattedStartDate = startDate.toLocaleDateString(lang, dateTimeOptions)

  if (isSameDate(startDate, endDate)) {
    const formattedEndTime = endDate.toLocaleTimeString(lang, timeOptions)
    return `${formattedStartDate} - ${formattedEndTime}`
  }

  const formattedEndDate = endDate.toLocaleDateString(lang, dateTimeOptions)
  return `${formattedStartDate} - ${formattedEndDate}`
}

function isSameDate (d1: Date, d2: Date) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
}

export default { formatStartAtForOverviewList, formatDateForEventView, isPastEvent }
